import type { SearchMode } from '../types/search-mode.type';

export type RecentSearchBadge = 'Smart' | 'Keyword' | 'Boolean';

/**
 * Recent-search row badge (TDD §3.7): `natural`/`job` → "Smart"; `keyword_boolean` →
 * "Boolean" when the query carried explicit operators, otherwise "Keyword".
 */
export function recentSearchBadge(
  searchMode: SearchMode,
  detectedBooleanOperators: boolean,
): RecentSearchBadge {
  if (searchMode === 'keyword_boolean') {
    return detectedBooleanOperators ? 'Boolean' : 'Keyword';
  }
  return 'Smart';
}
